// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchSellerDetailsByIdsParams = {
    authToken: string,
    deployment: string,
    sellerIds: number[],
};

export default {
    fetchSellerDetailsByIds: ({ authToken, deployment, sellerIds }: FetchSellerDetailsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>small/seller-detail' });
            request.send({ ids: sellerIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
